export default "###### Your 7 Day Guarantee!\n\nTry it for a week. If it's not for you, \\\nwe'll pick it up and refund you.\n";